export const SUPABASE_MIGRATIONS_FOLDER = 'supabase/migrations';

export function isDatabaseMigrationFile(relativePath: string) {
  return relativePath.startsWith(SUPABASE_MIGRATIONS_FOLDER) && relativePath.endsWith('.sql');
}

export function createDatabaseMigrationPath(name: string) {
  return `${SUPABASE_MIGRATIONS_FOLDER}/${generateMigrationTimestamp()}_${name}.sql`;
}

function generateMigrationTimestamp() {
  const now = new Date();

  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0');
  const day = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
}
